const horPillClassName = "hor-pill-item";
const activeClassName = "active";
const horPillItems = Array.from(document.getElementsByClassName(horPillClassName));

horPillItems.forEach(item => {
  item.addEventListener("click", (e) => {
    const horPillClicked = e.target.closest("." + horPillClassName);
    //If the pill clicked wasn't the already active pill then make it active and deactivate all other pill
    if (!horPillClicked.classList.contains(activeClassName)){
      //Find the currently active pill (if any) and remove it's active class
      horPillItems.find(item => item.classList.contains(activeClassName))?.classList.remove(activeClassName)
      horPillClicked.classList.add(activeClassName);
    }
  });
});

const collectionHorAccSwiperSpeed = 600;
const collectionHorAccSwiperPrevBtnClass = "collections-hor-acc-prev-btn";
const collectionHorAccSwiperNextBtnClass = "collections-hor-acc-next-btn";
const collectionHorAccSwiperPaginationClass = "collections-hor-acc-pagination";
const collectionHorAccSwiperSwiper = new Swiper(".collections-hor-acc-swiper", {
  // Optional parameters
  resistanceRatio:0,
  direction: "horizontal",
  shortSwipes: true,
  simulateTouch: true,
  slideToClickedSlide: false,
  loop: true,
  speed: collectionHorAccSwiperSpeed,
  autoHeight: true,
  effect: "slide",
  allowSlidePrev: true,
  allowSlideNext: true,
  allowTouchMove: true,
  slidesPerView: 1,
  // Navigation arrows
  navigation: {
    prevEl: "." + collectionHorAccSwiperPrevBtnClass,
    nextEl: "." + collectionHorAccSwiperNextBtnClass,
  },
  pagination: {
    el: "." + collectionHorAccSwiperPaginationClass,
    clickable: true,
    renderBullet: function (idx, className) {
      return `<div class="${className}"></div>`;
    },
  },
  on: {
  },
});